<template>
  <div>
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem"></b-spinner>
    </div>
    <b-card v-if="!loading">
      <b-card-body>
        <validation-observer ref="timesheet" #default="{ invalid }">
          <b-form @submit.prevent="formSubmitted">
            <b-row>
              <b-col md="3">
                <b-form-group label="Project" label-for="project-dropdown">
                  <validation-provider rules="required" #default="{ errors }" name="Project" vid="Project">
                    <b-form-select id="project-dropdown" 
                      v-model="timesheetDetails.parentID" 
                      :options="Projects" 
                      @change="fetchTasks(timesheetDetails.parentID)"
                      :disabled="type !== 'add' || dis !== 'add'" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Task" label-for="task-dropdown">
                  <validation-provider rules="required" #default="{ errors }" name="Task" vid="Task">
                    <b-form-select id="task-dropdown" 
                      v-model="timesheetDetails.typeID" 
                      :options="Tasks" 
                      :disabled="!selectedProject || type !== 'add' || dis !== 'add'" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Approver" label-for="mc-approver">
                  <validation-provider rules="required" #default="{ errors }" name="Approver" vid="Approver">
                    <b-form-select id="mc-approver" :disabled="type !== 'add'" v-model="timesheetDetails.approverID"
                      :options="userList" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Reference" label-for="mc-reference">
                  <validation-provider rules="required" #default="{ errors }" name="Reference" vid="Reference">
                  <b-form-input :disabled="type !== 'add'" id="mc-Reference" type="text"
                    v-model="timesheetDetails.reference" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Start Time" label-for="mc-startTime">
                  <validation-provider rules="required" #default="{ errors }" name="Start Time" vid="start Time">
                    <b-form-timepicker 
                      id="mc-startTime" 
                      :min="new Date()" 
                      v-model="timesheetDetails.startTime"
                      :disabled="type !== 'add'"
                      @change="calculateHoursWorked"
                      locale="en">
                    </b-form-timepicker>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                    </b-col>
                    <b-col md="3">
                      <b-form-group label="End Time" label-for="mc-endTime">
                        <validation-provider rules="required" #default="{ errors }" name="End Time" vid="end Time">
                          <b-form-timepicker 
                            id="mc-endTime" 
                            :min="new Date()" 
                            v-model="timesheetDetails.endTime"
                            :disabled="type !== 'add'"
                            @change="calculateHoursWorked"
                            locale="en">
                          </b-form-timepicker>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
              <b-col md="3">
                <b-form-group label="Hours Worked" label-for="mc-hours">
                  <validation-provider rules="required|min_value:0.01|max_value:24" #default="{ errors }"
                    name="Hours Worked" vid="Hours Worked">
                    <b-form-input
                      onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                      :disabled="type !== 'add'" id="mc-hours" type="text" v-model="timesheetDetails.hoursWorked" readonly />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Date" label-for="mc-date">
                  <validation-provider rules="required" #default="{ errors }" name="Date" vid="Date">
                    <b-form-datepicker :disabled="type !== 'add'" id="mc-date" :max="today"
                      v-model="timesheetDetails.date"></b-form-datepicker>
                    <!-- <flat-pickr :disabled="type === 'view'" v-model="timesheetDetails.date" class="form-control" :config="dateConfig" /> -->
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Description" label-for="mc-taskDescription">
                  <!-- <validation-provider rules="required" #default="{ errors }" name="Description" vid="Description"> -->
                    <b-form-textarea :disabled="type !== 'add'" id="mc-taskDescription" type="text"
                      v-model="timesheetDetails.taskDescription" />
                    <!-- <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider> -->
                </b-form-group>
              </b-col>
              <b-col v-if="type !== 'add'" md="6">
                <b-form-group label="Status" label-for="mc-status">
                  <validation-provider rules="required" #default="{ errors }" name="Status" vid="Status">
                    <b-form-select id="mc-status"
                      :disabled="(type === 'view' || timesheetDetails.approverID !== userId)"
                      v-model="timesheetDetails.status" :options="timesheetStatus" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col v-if="type !== 'add' && timesheetDetails.status === 'REJECTED'" md="6">
                <b-form-group label="Note" label-for="mc-note">
                  <validation-provider rules="required" #default="{ errors }" name="Note" vid="Note">
                    <b-form-input id="mc-note" :disabled="(type === 'view' || timesheetDetails.approverID !== userId)"
                      v-model="timesheetDetails.note" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="type !== 'view'">
              <b-col cols="12">
                <b-button v-if="userId !== timesheetDetails.approverID" variant="primary" class="mt-2 mr-1"
                  @click="submitTimesheet">
                  Save
                </b-button>
                <b-button v-else variant="primary" class="mt-2 mr-1" @click="submitTimesheet">
                  Update
                </b-button>
                <b-button variant="outline-secondary" type="button" class="mt-2" @click="resetTimesheet">
                  Cancel
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormDatepicker,
  BFormTimepicker,
  BInputGroupAppend,
  BButton,
  BDropdown,
  BDropdownItem,
  BSpinner,
  BCard,
  BCardText,
  BCardBody
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { customLoader, customError, customSwal, fnSortingDropdown } from '@/libs/customFn';
import '@/libs/customValidation';
import { TimesheetStatus } from '@/libs/defaultList';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BFormSelect,
    BCardText,
    BForm,
    BFormGroup,
    BSpinner,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BFormDatepicker,
    ValidationProvider,
    ValidationObserver,
    BFormTimepicker,
  },
  data() {
    return {
      id: this.$route.params.id,
      type: this.$route.meta.type,
      userData: JSON.parse(localStorage.getItem("userData")) || {},
      dis: "",
      today: new Date().toISOString().split("T")[0],
      timesheetDetails: {
        id: null,
        parentID: null,
        typeID: null,
        employeeID: null,
        date: null,
        hoursWorked: null,
        taskDescription: null,
        approverID: null,
        approvalDate: null,
        status: null,
        note: null,
        startDate: null,
        endDate: null,
        reference: null,
      },
      defaultTimesheet: {
        id: null,
        parentID: null,
        typeID: null,
        employeeID: null,
        date: null,
        hoursWorked: null,
        taskDescription: null,
        approverID: null,
        approvalDate: null,
        status: null,
        note: null,
        startDate: null,
        endDate: null,
        reference: null,
      },
      dateConfig: {
        wrap: true,
        maxDate: new Date(),
      },
      selectedProject: null,
      Projects: [],
      Tasks: [],
      userList: [],
      userId: null,
      timesheetStatus: TimesheetStatus,
      ProjectName: "",
      TaskName: "",
      ProjectData: null,
    };
  },
  computed: {
    ...mapGetters("serviceModule", {
      serviceOrderList: "serviceOrderList",
      timesheet: "timesheet",
      loading: "loading",
    }),
    ...mapGetters("projectModule", {
      projectsList: "projects",
      loading: "loading",
    }),
    ...mapGetters("userModule", {
      users: "users",
      loading: "loading",
    }),
  },
  methods: {
    ...mapActions("serviceModule", ["getServiceOrderListAction", "getServiceTimesheetAction", "postServiceTimesheetAction", "putServiceTimesheetAction"]),
    ...mapActions("projectModule", ["getProjectByIdAction","getProjectListAction","getProjectAssigneesAction", "getProjectTasksAction"]),
    ...mapActions("userModule", ["getUserListByRoleAction"]),
    async resetTimesheet() {
      this.timesheetDetails = this.defaultTimesheet;
    },
    errorStart(data) {
      let msg = null;
     // if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: "'End Time' cannot be before 'Start Time'.",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    errorTime(data) {
      let msg = null;
     // if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: "Please select a start time and end time.",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    convertToDate(time) {
  const [hours, minutes] = time.split(":");
  const date = new Date();
  date.setHours(hours, minutes, 0, 0); // Set hours and minutes, leaving seconds and milliseconds as 0
  return date;
},
    calculateHoursWorked() {
  if (this.timesheetDetails.startTime && this.timesheetDetails.endTime) {
    // Convert startTime and endTime strings to Date objects
    const start = this.convertToDate(this.timesheetDetails.startTime);
    const end = this.convertToDate(this.timesheetDetails.endTime);

    if(start > end){
      this.errorStart();
    }
    // Calculate the difference in milliseconds
    const diff = end - start;

    // Convert milliseconds to hours (if diff is positive)
    const hours = diff / (1000 * 60 * 60);

    this.timesheetDetails.hoursWorked = hours >= 0 ? hours : 0; // Ensure the value is non-negative
    this.timesheetDetails.hoursWorked = this.timesheetDetails.hoursWorked.toFixed(2);
    console.log("hoursworked", this.timesheetDetails.hoursWorked);
  }
},
    async submitTimesheet() {
      let isValid = await this.$refs.timesheet.validate();
      if (isValid) {
        this.timesheetDetails.moduleReference = 'Project';
      

       //SD ??? Logged user should be the one submitting
       this.timesheetDetails.employeeID = this.userData.id;


        //this.timesheetDetails.employeeID = this.Tasks.assignee;
        console.log("🚀 ~ submitTimesheet ~ Tasks:", this.timesheetDetails.employeeID)
        if (this.type === 'add') {
          let addLoader = customLoader('Please wait while timesheet is being saved');
          await this.postServiceTimesheetAction(this.timesheetDetails)
            .then((res) => {
              if (res.errors) {
                customError(res);
              } else if(res.success) {
                customSwal(res.message);
                this.$router.push("/projectmanagementtimesheet/list");
              } else {
                customError(res);
              }
            })
            .catch((err) => customError(err.response.data));
            addLoader.close();
        } else {
          let updateLoader = customLoader('Please wait while timesheet is being updated');
          
          await this.putServiceTimesheetAction(this.timesheetDetails)
            .then((res) => {
              if (res.errors) {
                customError(res);
              } else if(res.success) {
                customSwal(res.message);
                this.$router.push("/projectmanagementtimesheet/list");
              } else {
                customError(res);
              }
            })
            .catch((err) => customError(err.response.data));
            updateLoader.close();
        }
      }
    },

    async fetchTasks(parentID) {
  await this.getProjectByIdAction(parentID).then((projectData) => {
    if (projectData) {
      this.Projectdata = projectData;

      if (projectData.tasks && projectData.tasks.length > 0) {
          this.Tasks = projectData.tasks.map(task => ({
            text: task.title,
            value: task.id,
            assignee: task.assignee,
          }));
          console.log("🚀 ~ awaitthis.getProjectByIdAction ~ this.Tasks:", this.Tasks)
          this.selectedProject = true;
        } else {
          console.log("No tasks available for this project.");
          this.Tasks = [];
          this.selectedProject = false;
    }}
  });
  },

  },
  async mounted() {
    const modulereference = 'Project';
    this.dis = this.$route.params.id? "edit" : "add";
    const userData = JSON.parse(localStorage.getItem("userData"));
    this.userId = userData.id;

    if (this.type !== 'add') {
      await this.getServiceTimesheetAction({modulereference, id: this.id});
      this.defaultTimesheet = this.timesheet;
      this.timesheetDetails = this.timesheet;
      await this.fetchTasks(this.timesheet.parentID);
    const task = this.Tasks.find(task => {
      return task.value === this.timesheet.typeID
    })
    if (task) {
      this.timesheetDetails.typeID = this.timesheet.typeID;
      this.timesheetDetails.parentID = this.timesheet.parentID;
    } else {
      console.error("Task not found for the provided ID.");
    }
    }

    const { id: taskId, projectId } = this.$route.params;
    const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[4][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;

    if (taskId && projectId) {
    await this.fetchTasks(projectId);
    const task = this.Tasks.find(task => {
      return task.value === taskId
    })
    if (task) {
      this.timesheetDetails.typeID = taskId;
      this.timesheetDetails.parentID = projectId;
      this.timesheetDetails.employeeID = task.assignee;
    } else {
      console.error("Task not found for the provided ID.");
    }
  }

    await this.getProjectListAction().then(() => {
      this.Projects = this.projectsList.map((project) => { return { text: project.name, value: project.projectId, }; })
    }),

    await this.getUserListByRoleAction("staff").then(() => {
      let users = this.users.filter(
        (z) =>
          this.timesheetDetails.approverID === this.userId ||
          z.id !== this.userId
      );
      users = users.map((user) => {
        return { text: `${user.firstName} ${user.lastName}`, value: user.id };
      });
      this.userList = fnSortingDropdown(users);
    });

  },
  watch: {
    'timesheetDetails.typeID'(newTypeID) {
      console.log("🚀 ~ newTypeID:", newTypeID)
      const selectedTask = this.Tasks.find(task => task.value === newTypeID);
      if (selectedTask) {
        this.timesheetDetails.employeeID = selectedTask.assignee;
      } else {
        this.timesheetDetails.employeeID = null;
      }
    },
    'timesheetDetails.startTime': 'calculateHoursWorked',
    'timesheetDetails.endTime': 'calculateHoursWorked',
  },
};
</script>
